import React from "react";
import styled from "styled-components";
import { Helmet } from "react-helmet";
import { FaBox, FaSnowflake, FaTruck, FaWrench } from "react-icons/fa";

const Equipment = () => {
  const dryCargo20 = {
    exterior: {
      length: "19'10.5\" (6.06 m)",
      width: "8'0\" (2.43 m)",
      height: "8'6\" (2.59 m)",
    },
    interior: {
      length: "19'4\" (5.89 m)",
      width: "7'8.5\" (2.35 m)",
      height: "7'10\" (2.38 m)",
    },
    door: { width: "7'8.25\" (2.34 m)", height: "7'5.625\" (2.27 m)" },
    capacity: { weight: "4,960 lb (2,250 kg)", volume: "1,158 ft²" },
  };

  const dryCargo40 = {
    exterior: {
      length: "40'0\" (12.19 m)",
      width: "8'0\" (2.43 m)",
      height: "8'6\" (2.59 m)",
    },
    interior: {
      length: "39'6.81\" (12.05 m)",
      width: "7'8.5\" (2.35 m)",
      height: "7'9.75\" (2.38 m)",
    },
    door: { width: "7'8.25\" (2.34 m)", height: "7'5.688\" (2.27 m)" },
    capacity: { weight: "6,200 lb (2,810 kg)", volume: "2,383 ft² (67.4 m²)" },
  };

  const highCube40 = {
    exterior: {
      length: "40'0\" (12.19 m)",
      width: "8'0\" (2.43 m)",
      height: "9'6\" (2.89 m)",
    },
    interior: {
      length: "39'6.75\" (12.05 m)",
      width: "7'8.50\" (2.35 m)",
      height: "8'9.75\" (2.68 m)",
    },
    door: { width: "7'8.25\" (2.34 m)", height: "8'5.75\" (2.57 m)" },
    capacity: { weight: "6,600 lb (2,995 kg)", volume: "2,687 ft² (76.0 m²)" },
  };

  const highCube45 = {
    exterior: {
      length: "45'0\" (13.71 m)",
      width: "8'0\" (2.43 m)",
      height: "9'6\" (2.89 m)",
    },
    interior: {
      length: "44'6\" (13.58 m)",
      width: "7'8.50\" (2.35 m)",
      height: "8'9.75\" (2.68 m)",
    },
    door: { width: "7'8.25\" (2.34 m)", height: "8'5.75\" (2.57 m)" },
    capacity: { weight: "8,800 lb (3,990 kg)", volume: "3,026 ft² (85.6 m²)" },
  };

  const reefer40 = {
    exterior: {
      length: "40'0\" (12.19 m)",
      width: "8'0\" (2.43 m)",
      height: "8'6\" (2.59 m)",
    },
    interior: {
      length: "37'2\" (11.33 m)",
      width: "7'6\" (2.29 m)",
      height: "7'2.25\" (2.19 m)",
    },
    door: { width: "7'6\" (2.29 m)", height: "6'11.625\" (2.12 m)" },
    capacity: { weight: "9,970 lb (4,522 kg)", volume: "2,004 ft³ (56.75 m³)" },
  };

  const reeferHighCube40 = {
    exterior: {
      length: "40'0\" (12.19 m)",
      width: "8'0\" (2.43 m)",
      height: "9'6\" (2.90 m)",
    },
    interior: {
      length: "38'1.875\" (11.59 m)",
      width: "7'6.1875\" (2.29 m)",
      height: "8'3.125\" (2.52 m)",
    },
    door: { width: "7'6\" (2.28 m)", height: "8'.875\" (2.46 m)" },
    capacity: { weight: "9,240 lb (4,191 kg)", volume: "2,359 ft² (66.8 m²)" },
  };

  const openTop20 = {
    exterior: {
      length: "20'0\" (6.10 m)",
      width: "8'0\" (2.43 m)",
      height: "8'6.5\" (2.60 m)",
    },
    interior: {
      length: "19'4\" (5.89 m)",
      width: "7'8\" (2.33 m)",
      height: "7'10\" (2.26 m)",
    },
    door: { width: "7'8\" (2.33 m)", height: "7'6\" (2.28 m)" },
    capacity: { weight: "4,519 lb (2,050 kg)", volume: "1,158 ft² (33.8 m²)" },
  };

  const openTop40 = {
    exterior: {
      length: "40'0\" (12.19 m)",
      width: "8'0\" (2.43 m)",
      height: "8'6.5\" (2.60 m)",
    },
    interior: {
      length: "39'6.8\" (12.06 m)",
      width: "7'8.25\" (2.34 m)",
      height: "7'5.25\" (2.26 m)",
    },
    door: { width: "7'6\" (2.28 m)", height: "7'7.125\" (2.31 m)" },
    capacity: { weight: "8,270 lb (3,750 kg)", volume: "2,262 ft² (64.0 m²)" },
  };

  const flatBed20 = {
    exterior: {
      length: "19'10.5\" (6.06 m)",
      width: "8'0\" (2.43 m)",
      height: "8'6\" (2.59 m)",
    },
    interior: {
      length: "19'4\" (5.89 m)",
      width: "7'8.5\" (2.35 m)",
      height: "7'10\" (2.38 m)",
    },
    capacity: { weight: "5,137 lb (2,330 kg)", volume: "1,164 ft² (32.95 m²)" },
  };

  const flatBed40 = {
    exterior: {
      length: "40'0\" (12.19 m)",
      width: "8'0\" (2.43 m)",
      height: "8'6\" (2.59 m)",
    },
    interior: {
      length: "38'11\" (11.86 m)",
      width: "7'10.4375\" (2.39 m)",
      height: "6'5.25\" (1.69 m)",
    },
    capacity: {
      weight: "12,000 lb (5,670 kg)",
      volume: "1,972 ft² (32.95 m²)",
    },
  };

  return (
    <>
      <Helmet>
        <title>Equipment | Trans World Shipping Company</title>
        <meta
          name="description"
          content="Explore our extensive fleet of shipping containers including dry cargo, reefer, open top, and flat bed containers for all your logistics needs."
        />
        <link rel="canonical" href="https://transworldshipping.com/equipment" />
      </Helmet>

      <TheEquipment>
        <div className="equipment-hero">
          <div className="hero-overlay"></div>
          <div className="hero-content">
            <h1>Our Equipment Fleet</h1>
            <p>Comprehensive container solutions for every shipping need</p>
          </div>
        </div>

        <div className="equipment-container">
          {/* Dry Cargo Section */}
          <section className="equipment-section">
            <h2>
              <FaBox /> Dry Cargo Containers
            </h2>
            <div className="header-line"></div>

            <div className="equipment-card">
              <h3>20 Foot Dry Cargo</h3>
              <div className="specs-grid">
                <div className="spec-group">
                  <h4>Exterior</h4>
                  <p>Length: {dryCargo20.exterior.length}</p>
                  <p>Width: {dryCargo20.exterior.width}</p>
                  <p>Height: {dryCargo20.exterior.height}</p>
                </div>
                <div className="spec-group">
                  <h4>Interior</h4>
                  <p>Length: {dryCargo20.interior.length}</p>
                  <p>Width: {dryCargo20.interior.width}</p>
                  <p>Height: {dryCargo20.interior.height}</p>
                </div>
                <div className="spec-group">
                  <h4>Door Opening</h4>
                  <p>Width: {dryCargo20.door.width}</p>
                  <p>Height: {dryCargo20.door.height}</p>
                </div>
                <div className="spec-group">
                  <h4>Capacity</h4>
                  <p>Max Weight: {dryCargo20.capacity.weight}</p>
                  <p>Volume: {dryCargo20.capacity.volume}</p>
                </div>
              </div>
            </div>

            <div className="equipment-card">
              <h3>40 Foot Dry Cargo</h3>
              <div className="specs-grid">
                <div className="spec-group">
                  <h4>Exterior</h4>
                  <p>Length: {dryCargo40.exterior.length}</p>
                  <p>Width: {dryCargo40.exterior.width}</p>
                  <p>Height: {dryCargo40.exterior.height}</p>
                </div>
                <div className="spec-group">
                  <h4>Interior</h4>
                  <p>Length: {dryCargo40.interior.length}</p>
                  <p>Width: {dryCargo40.interior.width}</p>
                  <p>Height: {dryCargo40.interior.height}</p>
                </div>
                <div className="spec-group">
                  <h4>Door Opening</h4>
                  <p>Width: {dryCargo40.door.width}</p>
                  <p>Height: {dryCargo40.door.height}</p>
                </div>
                <div className="spec-group">
                  <h4>Capacity</h4>
                  <p>Max Weight: {dryCargo40.capacity.weight}</p>
                  <p>Volume: {dryCargo40.capacity.volume}</p>
                </div>
              </div>
            </div>

            <div className="equipment-card">
              <h3>40 Foot High Cube Dry Cargo</h3>
              <div className="specs-grid">
                <div className="spec-group">
                  <h4>Exterior</h4>
                  <p>Length: {highCube40.exterior.length}</p>
                  <p>Width: {highCube40.exterior.width}</p>
                  <p>Height: {highCube40.exterior.height}</p>
                </div>
                <div className="spec-group">
                  <h4>Interior</h4>
                  <p>Length: {highCube40.interior.length}</p>
                  <p>Width: {highCube40.interior.width}</p>
                  <p>Height: {highCube40.interior.height}</p>
                </div>
                <div className="spec-group">
                  <h4>Door Opening</h4>
                  <p>Width: {highCube40.door.width}</p>
                  <p>Height: {highCube40.door.height}</p>
                </div>
                <div className="spec-group">
                  <h4>Capacity</h4>
                  <p>Max Weight: {highCube40.capacity.weight}</p>
                  <p>Volume: {highCube40.capacity.volume}</p>
                </div>
              </div>
            </div>

            <div className="equipment-card">
              <h3>45 Foot High Cube Dry Cargo</h3>
              <div className="specs-grid">
                <div className="spec-group">
                  <h4>Exterior</h4>
                  <p>Length: {highCube45.exterior.length}</p>
                  <p>Width: {highCube45.exterior.width}</p>
                  <p>Height: {highCube45.exterior.height}</p>
                </div>
                <div className="spec-group">
                  <h4>Interior</h4>
                  <p>Length: {highCube45.interior.length}</p>
                  <p>Width: {highCube45.interior.width}</p>
                  <p>Height: {highCube45.interior.height}</p>
                </div>
                <div className="spec-group">
                  <h4>Door Opening</h4>
                  <p>Width: {highCube45.door.width}</p>
                  <p>Height: {highCube45.door.height}</p>
                </div>
                <div className="spec-group">
                  <h4>Capacity</h4>
                  <p>Max Weight: {highCube45.capacity.weight}</p>
                  <p>Volume: {highCube45.capacity.volume}</p>
                </div>
              </div>
            </div>
          </section>

          {/* Reefer Section */}
          <section className="equipment-section">
            <h2>
              <FaSnowflake /> Reefer Containers
            </h2>
            <div className="header-line"></div>

            <div className="equipment-card">
              <h3>40 Foot Reefer Cargo</h3>
              <div className="specs-grid">
                <div className="spec-group">
                  <h4>Exterior</h4>
                  <p>Length: {reefer40.exterior.length}</p>
                  <p>Width: {reefer40.exterior.width}</p>
                  <p>Height: {reefer40.exterior.height}</p>
                </div>
                <div className="spec-group">
                  <h4>Interior</h4>
                  <p>Length: {reefer40.interior.length}</p>
                  <p>Width: {reefer40.interior.width}</p>
                  <p>Height: {reefer40.interior.height}</p>
                </div>
                <div className="spec-group">
                  <h4>Door Opening</h4>
                  <p>Width: {reefer40.door.width}</p>
                  <p>Height: {reefer40.door.height}</p>
                </div>
                <div className="spec-group">
                  <h4>Capacity</h4>
                  <p>Max Weight: {reefer40.capacity.weight}</p>
                  <p>Volume: {reefer40.capacity.volume}</p>
                </div>
              </div>
              <p className="note">
                *Tare weight varies depending on Reefer unit type and container
                manufacturer. Consideration should be given for genset weight.
              </p>
            </div>

            <div className="equipment-card">
              <h3>40 Foot High Cube Reefer Cargo</h3>
              <div className="specs-grid">
                <div className="spec-group">
                  <h4>Exterior</h4>
                  <p>Length: {reeferHighCube40.exterior.length}</p>
                  <p>Width: {reeferHighCube40.exterior.width}</p>
                  <p>Height: {reeferHighCube40.exterior.height}</p>
                </div>
                <div className="spec-group">
                  <h4>Interior</h4>
                  <p>Length: {reeferHighCube40.interior.length}</p>
                  <p>Width: {reeferHighCube40.interior.width}</p>
                  <p>Height: {reeferHighCube40.interior.height}</p>
                </div>
                <div className="spec-group">
                  <h4>Door Opening</h4>
                  <p>Width: {reeferHighCube40.door.width}</p>
                  <p>Height: {reeferHighCube40.door.height}</p>
                </div>
                <div className="spec-group">
                  <h4>Capacity</h4>
                  <p>Max Weight: {reeferHighCube40.capacity.weight}</p>
                  <p>Volume: {reeferHighCube40.capacity.volume}</p>
                </div>
              </div>
              <p className="note">
                *Tare weight varies depending on Reefer unit type and container
                manufacturer. Consideration should be given for genset weight.
              </p>
            </div>
          </section>

          {/* Open Top Section */}
          <section className="equipment-section">
            <h2>
              <FaWrench /> Open Top Containers
            </h2>
            <div className="header-line"></div>

            <div className="equipment-card">
              <h3>20 Foot Open Top</h3>
              <div className="specs-grid">
                <div className="spec-group">
                  <h4>Exterior</h4>
                  <p>Length: {openTop20.exterior.length}</p>
                  <p>Width: {openTop20.exterior.width}</p>
                  <p>Height: {openTop20.exterior.height}</p>
                </div>
                <div className="spec-group">
                  <h4>Interior</h4>
                  <p>Length: {openTop20.interior.length}</p>
                  <p>Width: {openTop20.interior.width}</p>
                  <p>Height: {openTop20.interior.height}</p>
                </div>
                <div className="spec-group">
                  <h4>Door Opening</h4>
                  <p>Width: {openTop20.door.width}</p>
                  <p>Height: {openTop20.door.height}</p>
                </div>
                <div className="spec-group">
                  <h4>Capacity</h4>
                  <p>Max Weight: {openTop20.capacity.weight}</p>
                  <p>Volume: {openTop20.capacity.volume}</p>
                </div>
              </div>
            </div>

            <div className="equipment-card">
              <h3>40 Foot Open Top</h3>
              <div className="specs-grid">
                <div className="spec-group">
                  <h4>Exterior</h4>
                  <p>Length: {openTop40.exterior.length}</p>
                  <p>Width: {openTop40.exterior.width}</p>
                  <p>Height: {openTop40.exterior.height}</p>
                </div>
                <div className="spec-group">
                  <h4>Interior</h4>
                  <p>Length: {openTop40.interior.length}</p>
                  <p>Width: {openTop40.interior.width}</p>
                  <p>Height: {openTop40.interior.height}</p>
                </div>
                <div className="spec-group">
                  <h4>Door Opening</h4>
                  <p>Width: {openTop40.door.width}</p>
                  <p>Height: {openTop40.door.height}</p>
                </div>
                <div className="spec-group">
                  <h4>Capacity</h4>
                  <p>Max Weight: {openTop40.capacity.weight}</p>
                  <p>Volume: {openTop40.capacity.volume}</p>
                </div>
              </div>
            </div>
            <p className="note">
              *All specifications are for Transworld Shipping (USA) Inc. owned
              equipment. Dimensions of leased equipment may differ slightly.
            </p>
          </section>

          {/* Flat Bed Section */}
          <section className="equipment-section">
            <h2>
              <FaTruck /> Flat Bed Containers
            </h2>
            <div className="header-line"></div>

            <div className="equipment-card">
              <h3>20 Foot Flat Bed</h3>
              <div className="specs-grid">
                <div className="spec-group">
                  <h4>Exterior</h4>
                  <p>Length: {flatBed20.exterior.length}</p>
                  <p>Width: {flatBed20.exterior.width}</p>
                  <p>Height: {flatBed20.exterior.height}</p>
                </div>
                <div className="spec-group">
                  <h4>Interior</h4>
                  <p>Length: {flatBed20.interior.length}</p>
                  <p>Width: {flatBed20.interior.width}</p>
                  <p>Height: {flatBed20.interior.height}</p>
                </div>
                <div className="spec-group">
                  <h4>Capacity</h4>
                  <p>Max Weight: {flatBed20.capacity.weight}</p>
                  <p>Volume: {flatBed20.capacity.volume}</p>
                </div>
              </div>
            </div>

            <div className="equipment-card">
              <h3>40 Foot Flat Bed</h3>
              <div className="specs-grid">
                <div className="spec-group">
                  <h4>Exterior</h4>
                  <p>Length: {flatBed40.exterior.length}</p>
                  <p>Width: {flatBed40.exterior.width}</p>
                  <p>Height: {flatBed40.exterior.height}</p>
                </div>
                <div className="spec-group">
                  <h4>Interior</h4>
                  <p>Length: {flatBed40.interior.length}</p>
                  <p>Width: {flatBed40.interior.width}</p>
                  <p>Height: {flatBed40.interior.height}</p>
                </div>
                <div className="spec-group">
                  <h4>Capacity</h4>
                  <p>Max Weight: {flatBed40.capacity.weight}</p>
                  <p>Volume: {flatBed40.capacity.volume}</p>
                </div>
              </div>
              <p className="note">
                *We also offer 40 foot fixed-end, collapsible, and collapsible
                flush flat beds.
              </p>
            </div>
          </section>
        </div>
      </TheEquipment>
    </>
  );
};

const TheEquipment = styled.div`
  width: 100%;
  background: #ffffff;

  .equipment-hero {
    position: relative;
    width: 100%;
    height: 40vh;
    min-height: 300px;
    background: linear-gradient(135deg, #0b1e33 0%, #0a1a2c 100%);

    .hero-overlay {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: radial-gradient(
        circle at 30% 50%,
        rgba(212, 175, 55, 0.1) 0%,
        transparent 70%
      );
    }

    .hero-content {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      text-align: center;
      color: white;
      width: 100%;
      padding: 0 2rem;
      z-index: 1;

      h1 {
        font-size: 3rem;
        font-weight: 700;
        margin-bottom: 1rem;
      }

      p {
        font-size: 1.2rem;
        opacity: 0.9;
      }
    }
  }

  .equipment-container {
    max-width: 1400px;
    margin: 0 auto;
    padding: 4rem 2rem;
  }

  .equipment-section {
    margin-bottom: 4rem;

    h2 {
      font-size: 2rem;
      color: #0b1e33;
      margin-bottom: 1rem;
      display: flex;
      align-items: center;
      gap: 0.75rem;

      svg {
        color: #d4af37;
      }
    }

    .header-line {
      width: 60px;
      height: 3px;
      background: #d4af37;
      margin-bottom: 2rem;
    }
  }

  .equipment-card {
    background: #f8f9fa;
    border-radius: 12px;
    padding: 1.5rem;
    margin-bottom: 1.5rem;
    border: 1px solid #e2e8f0;
    transition: all 0.3s ease;

    &:hover {
      box-shadow: 0 8px 20px rgba(0, 0, 0, 0.08);
      border-color: #d4af37;
    }

    h3 {
      font-size: 1.3rem;
      color: #0b1e33;
      margin-bottom: 1.25rem;
      padding-bottom: 0.5rem;
      border-bottom: 2px solid #d4af37;
      display: inline-block;
    }

    .specs-grid {
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      gap: 1.5rem;
      margin-bottom: 1rem;
    }

    .spec-group {
      h4 {
        font-size: 0.85rem;
        color: #d4af37;
        text-transform: uppercase;
        letter-spacing: 1px;
        margin-bottom: 0.75rem;
      }

      p {
        font-size: 0.9rem;
        color: #4a5568;
        margin-bottom: 0.25rem;
        line-height: 1.4;
      }
    }

    .note {
      font-size: 0.75rem;
      color: #718096;
      margin-top: 1rem;
      padding-top: 0.75rem;
      border-top: 1px solid #e2e8f0;
      font-style: italic;
    }
  }

  @media screen and (max-width: 1200px) {
    .equipment-container {
      padding: 3rem 1.5rem;
    }

    .equipment-card .specs-grid {
      grid-template-columns: repeat(2, 1fr);
      gap: 1rem;
    }
  }

  @media screen and (max-width: 900px) {
    .equipment-hero .hero-content h1 {
      font-size: 2.5rem;
    }

    .equipment-section h2 {
      font-size: 1.6rem;
    }
  }

  @media screen and (max-width: 768px) {
    .equipment-hero {
      min-height: 250px;

      .hero-content h1 {
        font-size: 2rem;
      }

      .hero-content p {
        font-size: 1rem;
      }
    }

    .equipment-container {
      padding: 2rem 1rem;
    }

    .equipment-card {
      padding: 1rem;

      h3 {
        font-size: 1.1rem;
      }

      .specs-grid {
        grid-template-columns: 1fr;
        gap: 0.75rem;
      }

      .spec-group {
        p {
          font-size: 0.85rem;
        }
      }
    }
  }

  @media screen and (max-width: 600px) {
    .equipment-hero .hero-content h1 {
      font-size: 1.6rem;
    }

    .equipment-section h2 {
      font-size: 1.3rem;
    }
  }

  @media screen and (max-width: 480px) {
    .equipment-hero .hero-content h1 {
      font-size: 1.3rem;
    }

    .equipment-card .note {
      font-size: 0.7rem;
    }
  }
`;

export default Equipment;
